import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { AttributeService } from '../../core/services/attributes.service';
import { AttributeValue, AttributeValueDialog } from 'src/app/models/attribute';
import { attributeType } from 'src/app/core/const/attributeTypeConst';

@Component({
  selector: 'megastore-admin-add-attribute-value',
  templateUrl: './add-attributeValue.component.html',
  styleUrls: ['./add-attributeValue.component.scss']
})
export class AddAttributeValueComponent {
  attributeValueFormGroup: FormGroup;
  submitted = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  attributeType = attributeType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AttributeValueDialog,
    private dialog: MatDialogRef<AddAttributeValueComponent>,
    private formBuilder: FormBuilder,
    private AttributeService: AttributeService,
    private _toasterService: ToasterService,
    private _spinnerService: SpinnerService,
    private _translateService: TranslateService
  ) {
    this.attributeValueFormGroup = this.formBuilder.group({
      label: ['', [Validators.required]],
      label_ar: ['', [Validators.required]],
      value: ['', [Validators.required]],
      value_ar: ['', [Validators.required]]
    });
    if (data.data) {
      this.attributeValueFormGroup.patchValue({
        label: data.data.label,
        label_ar: data.data.label_ar || '',
        value: data.data.value,
        value_ar: data.data.value_ar || ''
      });
    }
  }

  onSubmit(): void {
    this.submitted = true;
    this.attributeValueFormGroup.patchValue({
      label: this.attributeValueFormGroup.get('label')?.value.trim(),
      label_ar: this.attributeValueFormGroup.get('label_ar')?.value.trim()
    });
    const payload: AttributeValue = {
      label: this.attributeValueFormGroup.get('label')?.value,
      label_ar: this.attributeValueFormGroup.get('label_ar')?.value,
      value: this.attributeValueFormGroup.get('value')?.value,
      value_ar: this.attributeValueFormGroup.get('value_ar')?.value,
      parentId: this.data.attributeId,
      categoryId: this.data.categoryId
    };
    if (this.attributeValueFormGroup.valid) {
      this.onFormValid(payload);
    } else {
      this.attributeValueFormGroup.markAllAsTouched();
    }
  }

  onFormValid(payload: AttributeValue): void {
    this._spinnerService.addToLoader('addAttributeValue');
    (this.data.data && this.data.data._id ? this.AttributeService.editAttributeValue(payload, this.data.data._id) : this.AttributeService.addAttribute(payload)
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: AttributeValue) => {
          if (res) {
            this._spinnerService.removeFromLoader('addAttributeValue');
            this._toasterService.successToastr(
              this._translateService.instant('Successful')
            );
            this.dialog.close(res);
          }
        },
        error: () => {
          this._spinnerService.removeFromLoader('addAttributeValue');
        }
      });
  }
}
